export default __webpack_public_path__ + "static/media/AnimalMondey01_05.3058906c.png";